<template>
  <div>
    <div class="page-title">Edit Project Form</div>
    <Form
      v-if="form"
      btnText="Update Project"
      :submit="update"
      v-model="form"
    />
    <Spinner v-else />
  </div>
</template>

<script>
import Form from "./_form.internal_projects.page";
export default {
  components: { Form },
  data() {
    return {
      form: null,
    };
  },
  created() {
    this.setForm();
  },
  methods: {
    async update() {
      await this.$api.InternalProject.update(this.form);
      this.$router.push("/internal_projects");
    },
    async setForm() {
      const { data } = await this.$api.InternalProject.get({
        id: this.$route.params.id,
      });
      this.form = data;
    },
  },
};
</script>

<style></style>
